query allMarketSegmentsBySportId(
  $filter: MarketSegmentFilter,
  ) {
  marketSegments: allMarketSegments(
      filter: $filter
    ) {
    nodes {
      label
      name
    }
  }
}
